import { AiGlyph } from '../../../../monitoring/messages/triage/AiGlyph';

export function AiDraftNote({ text }: { text: string }) {
    return (
        <div className="flex justify-center py-1">
            <span className="inline-flex items-center gap-1 text-xs text-violet-600">
                <AiGlyph className="text-[11px]" />
                {text}
            </span>
        </div>
    );
}
